import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, Switch } from '@mui/material';
export const DzPreSoldSwitch = ({ checked, onChange }) => {
    return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center" }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2" }, { children: "Did you \"Pre-Sell\" a membership?" })), _jsx(Box, Object.assign({ display: "flex", flexDirection: "row", alignItems: "center" }, { children: _jsx(Switch, { checked: checked, onChange: onChange }) }))] })));
};
